<template>
  <section class="accordions">
    <section
      class="accordion"
      v-for="(guide, guideIndex) in templeGuides"
      :key="guideIndex"
    >
      <h3
        class="accordion__headline"
        @click="$emit('update:toggleTempleGuide', guideIndex)"
        title="[展開]更多資訊"
      >
        <span class="accordion__order">{{ guideIndex + 1 }}</span>
        {{ guide.name ? guide.name : "藝品介紹" }}
        <button
          title="查看完整介紹"
          :class="[
            'accordion__controls',
            { 'accordion__controls--open': guide.ariaExpanded },
          ]"
          :id="`accordion_control_${guideIndex + 1}`"
          :aria-controls="`position_${guideIndex + 1}`"
          :aria-expanded="guide.ariaExpanded.toString()"
          @keydown="$emit('update:toggleTempleGuide', guideIndex)"
        >
          <span class="u-hidden-visually">查看{{ guide.name }}的完整介紹</span>
        </button>
      </h3>

      <section
        role="region"
        :id="`position_${guideIndex + 1}`"
        :class="[
          'accordion__content',
          { 'accordion__content--open': guide.ariaExpanded },
        ]"
        :aria-labelledby="`accordion_control_${guideIndex + 1}`"
        :aria-hidden="(!guide.ariaExpanded).toString()"
        v-for="(artwork, artworkIndex) in guide.artworks"
        :key="artworkIndex"
      >
        <ArticleMastHead
          :cover_media="getArtworkCoverMedia(artwork)"
          :identity="artwork.identity"
          :space="artwork.space"
          :isNested="true"
          :isMainContent="false"
        />

        <section class="article">
          <ArticleParagraphs
            :category="'artwork'"
            :paragraphs="artwork.paragraphs"
            :isNested="true"
          >
            <template>
              <div class="check-out-artwork">
                <router-link
                  title="[前往]查看藝品"
                  :to="{
                    name: 'artwork',
                    params: {
                      articleId: guide.artworks[0].id,
                    },
                  }"
                >
                  <img
                    src="../assets/images/article/see-more-btn.svg"
                    alt="查看藝品"
                /></router-link>
              </div>
            </template>
          </ArticleParagraphs>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
import ArticleMastHead from "@/components/article/ArticleMastHead";
import ArticleParagraphs from "@/components/article/ArticleParagraphs";

export default {
  name: "TempleGuideAccordion",
  props: {
    templeGuides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getArtworkCoverMedia(artwork) {
      const video = artwork.cover_video;
      const image = artwork.cover_image_url;
      let videoParam;

      if (video) {
        // 當網址是 https://www.youtube.com/watch?v=qgICMuxC4RY 或是 https://youtu.be/qgICMuxC4RY
        videoParam = video.search("watch")
          ? video.split("/")[3].split("?v=")[1]
          : video.split("/")[3];
      }

      return video
        ? {
            type: "video",
            reference: videoParam,
            description: artwork.cover_video_description,
          }
        : {
            type: "image",
            reference: image,
            description: artwork.cover_image_description,
          };
    },
  },
  components: {
    ArticleMastHead,
    ArticleParagraphs,
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  color: $color-light-text;
  &__headline {
    position: relative;
    margin: 0;
    padding: 9px 45px 9px 15px;
    border-top: 1px solid;
    border-bottom: 1px solid;
    font-size: 1.5rem;
    line-height: 1.5;
    cursor: pointer;
    color: $color-light-text;
    text-align: left;
  }

  &__controls {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 50px;
    padding: 0;
    cursor: pointer;
    transform: rotate(180deg);
    transition: transform ease-in 0.25s;
    @include button-theme(fake);
    outline: none; // 防止收合時的旋轉效果

    &:focus {
      outline: none; // 防止收合時的旋轉效果
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      bottom: 24px;
      width: 15px;
      height: 3px;
      background: $color-order-border;
      border-radius: 5px;
    }

    &::before {
      transform: rotate(45deg);
      right: 21px;
    }

    &::after {
      transform: rotate(-45deg);
      right: 12px;
    }

    &--open {
      transform: rotate(0deg);

      &::before,
      &::after {
        bottom: 25px;
      }
    }
  }

  &__order {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: $color-light-order-bg;
    color: $color-tag-text;
    font-size: 1rem;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: relative;
    top: -2px;
  }

  &__content {
    max-height: 0;
    overflow: hidden;
    transition: max-height ease 0.25s;

    &--open {
      max-height: 7500px;
      overflow: auto;
    }
  }

  /* 手風琴的藝品內文設定 */
  /deep/ .article-head__other-fields {
    max-width: 100%;
  }
  /deep/ .paragraph {
    @include for-desktop {
      width: 100%;
    }

    &__sub-paragraphs {
      padding: 0;
    }
  }
  /deep/ .paragraph__content {
    p,
    h3 {
      @include for-tablet {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}

.accordion + .accordion {
  margin-top: -1px;
}

.check-out-artwork {
  text-align: center;
  margin-top: 20px;
}
</style>
